export default "__VITE_ASSET__Km9lzEet__"